<template>
  <v-hover
    v-slot="{ hover }"
  >
    <v-card
      :id="`fila-atendimento-${filaDeAtendimento.id}-${filaDeAtendimento.nome.toLowerCase()}`"
      width="350"
      class="mx-auto"
      :elevation="hover ? '20' : '1'"
    >
      <v-card-title class="align-start py-0">
        <div>
          <p class="mb-0 font-weight-bold text-2xl mt-4">
            {{ filaDeAtendimento.nome }}
          </p>
          <small class="text--secondary text-xs text--wrap">{{ filaDeAtendimento.descricao }}</small>
          <p>
            <v-chip
              class="v-chip-light-bg font-weight-semibold text-capitalize mt-2"
              small
              :class="filaDeAtendimento.papelId === EquipeFuncaoEnum.Gestor.id ? 'accent--text' : 'primary--text'"
              :color="filaDeAtendimento.papelId === EquipeFuncaoEnum.Gestor.id ? 'accent' : 'primary'"
            >
              {{ filaDeAtendimento.papelNome }}
            </v-chip>
          </p>
        </div>
      </v-card-title>

      <v-card-text>
        <div class="d-flex justify-center mb-4"></div>
        </div>

      </div>

        <v-list
          two-line
          subheader
        >
          <v-list-item
            class="pa-0"
          >
            <v-list-item-avatar
              class="v-avatar-light-bg success--text justify-center"
              size="40"
              rounded
            >
              <v-icon
                size="30"
                color="success"
              >
                {{ icons.mdiAccountPlus }}
              </v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title class="font-weight-semibold">
                NOVOS
              </v-list-item-title>

              <v-list-item-subtitle>{{ filaDeAtendimento.qtdeTicketsNovos }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            class="pa-0"
          >
            <v-list-item-avatar
              class="v-avatar-accent-bg justify-center"
              size="40"
              rounded
              color="accent"
            >
              <v-icon
                size="30"
                color="white"
              >
                {{ icons.mdiAccountClock }}
              </v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title class="font-weight-semibold">
                EM ANDAMENTO
              </v-list-item-title>

              <v-list-item-subtitle>{{ filaDeAtendimento.qtdeTicketsEmAndamento }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

          <v-btn
            block
            :color="'primary'"
            :to="to"
          >
            ACESSAR
            <v-icon
              color="dark"
              class="mx-1"
            >
              {{ icons.mdiArrowRight }}
            </v-icon>
          </v-btn>
      </v-card-text>
    </v-card>
  </v-hover>
</template>

<script>
import { mdiAccountPlus, mdiAccountClock, mdiArrowRight } from '@mdi/js'
import { getVuetify } from '@core/utils'
import { computed } from '@vue/composition-api'
import EquipeFuncaoEnum from '@/models/entities/equipe/EquipeFuncaoEnum'
import SlaBadgeAzul from '@/components/sla-badge/SlaBadgeAzul.vue'
import SlaBadgeVerde from '@/components/sla-badge/SlaBadgeVerde.vue'
import SlaBadgeLaranja from '@/components/sla-badge/SlaBadgeLaranja.vue'
import SlaBadgeVermelho from '@/components/sla-badge/SlaBadgeVermelho.vue'

export default {
  components: {
    SlaBadgeAzul,
    SlaBadgeVerde,
    SlaBadgeLaranja,
    SlaBadgeVermelho,
  },

  props: {
    filaDeAtendimento: {
      type: Object,
      default: () => {},
    },
    rotaAgente: {
      type: String,
      required: true,
    },
    rotaGestor: {
      type: String,
      required: true,
    },
    qtdSlaPrimeiraRespostaTicketAlertaAzul: {
      type: Number,
      required: true,
    },
    qtdSlaPrimeiraRespostaTicketAlertaVerde: {
      type: Number,
      required: true,
    },
    qtdSlaPrimeiraRespostaTicketAlertaLaranja: {
      type: Number,
      required: true,
    },
    qtdSlaPrimeiraRespostaTicketAlertaVermelho: {
      type: Number,
      required: true,
    },
    qtdSlaFinalizacaoTicketAlertaAzul: {
      type: Number,
      required: true,
    },
    qtdSlaFinalizacaoTicketAlertaVerde: {
      type: Number,
      required: true,
    },
    qtdSlaFinalizacaoTicketAlertaLaranja: {
      type: Number,
      required: true,
    },
    qtdSlaFinalizacaoTicketAlertaVermelho: {
      type: Number,
      required: true,
    },
  },

  setup(props) {
    const to = computed(() => {
      const query = {
        ...(props.filaDeAtendimento.id && { filaId: props.filaDeAtendimento.id }),
        filaNome: props.filaDeAtendimento.nome,
      }

      return {
        name: props.filaDeAtendimento.papelId === EquipeFuncaoEnum.Gestor.id ? props.rotaGestor : props.rotaAgente,
        query,
      }
    })

    const $vuetify = getVuetify()

    const chartOptions = {
      colors: [
        $vuetify.theme.currentTheme.primary,
        $vuetify.theme.currentTheme.success,
        $vuetify.theme.currentTheme.secondary,
      ],
      chart: {
        type: 'bar',
        stacked: true,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 10,
          columnWidth: '35%',
          startingShape: 'rounded',
          endingShape: 'rounded',
        },
      },
    }

    return {
      to,
      chartOptions,
      icons: {
        mdiAccountPlus,
        mdiAccountClock,
        mdiArrowRight,
      },
      EquipeFuncaoEnum,
    }
  },
}
</script>
